import React, {useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";
import {debounce} from "lodash";

const SearchForm = (props) => {
    const { t } = useTranslation();
    const { data, placeholder, personnification } = props;

    //const [firstLoad,setFirstLoad] = useState(true);
    //const [searchQuery,setSearchQuery] = useState('');
    //const [searchResults, setSearchResults] = useState(props.data);

    const applySearchResults = (results, searchQuery = null) => {
        if (data) {
            // Data isn't empty, we can move on
            if (!results) {
                return props.updateData([], searchQuery);
            } // foolproofing
            /*if(!objectEquals(results,currentData)){
                // Update items with the searchResults
                return props.updateData(results, searchQuery);
            }*/
            return props.updateData(results, searchQuery);
        }
    }

    useEffect(() => {
        /* if(data && Array.isArray(data) && data.length > 0 && !searchQuery){
            applySearchResults(data);
        } */
    }, [data]);

    const objectEquals = (a,b) => {
        return Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            JSON.stringify(a) === JSON.stringify(b);
    }

    const findObject = (obj = {}, query) => {
        for (const [key, value] of Object.entries(obj)) {
            if (typeof value === "string") {
                if (value.toLowerCase().includes(query.toLowerCase())) {
                    return true;
                }
            } else if (typeof value === "object" && value !== null) {
                if (findObject(value, query)) {
                     return true;
                }
            }
        }
        return undefined;
    }

    const onSearchChangeHandler = debounce((query) => {
        const queryCleaned = query.trim();

        if (personnification){
            props.setSearchQuery(queryCleaned);
        }
        else{
            if (!queryCleaned) {
                // empty query, recent with original data
                return applySearchResults([...data], queryCleaned);
            } else {
                // find results in the object using query
                const oldData = [...data];
                const searchResults = oldData.filter((item) => findObject(item, queryCleaned));
                // set results state to update items
                return applySearchResults(searchResults, queryCleaned);
            }
        }
    }, 300);

    return (

        <div className="search-form flex">
            <div className="flex flex-grow-1 align-items-center">
                <input
                    type="search"
                    className="form-control"
                    id="search"
                    aria-label="Search"
                    placeholder={t((placeholder?placeholder:`docs.invoices.table.search_placeholder`))}
                    onChange={(e) => onSearchChangeHandler(e.target.value)}
                />
                <i className="far fa-search"></i>
            </div>
        </div>
    );
};

export default SearchForm;
